import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, CMYK } from "../lib/data";

export const Services = () => (
  <section id="services" data-testid="services-section" className="border-b border-black">
    <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-black/60 mb-4">( Capabilities )</p>
      <h2 className="font-display font-bold uppercase tracking-tight leading-none text-4xl sm:text-6xl mb-16">
        What we <span className="text-[#FF3B30]">print</span>
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-black">
        {SERVICES.map((s, i) => (
          <motion.a
            href="#contact"
            key={s.num}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
            className="group relative border-r border-b border-black p-8 md:p-10 min-h-[240px] flex flex-col justify-between hover:bg-black hover:text-[#F4F4F0] transition-colors duration-300"
            data-testid={`service-card-${s.title.toLowerCase()}`}
          >
            <span className="absolute top-0 left-0 w-full h-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" style={{ background: CMYK[i % 4] === "#0E0E0E" ? "#FF3B30" : CMYK[i % 4] }} />
            <div className="flex items-start justify-between">
              <span className="font-mono text-sm font-semibold px-2 py-0.5 border border-black group-hover:border-[#F4F4F0]/40" style={{ background: CMYK[i % 4] === "#0E0E0E" ? "#FF3B30" : CMYK[i % 4], color: "#0E0E0E" }}>
                {s.num}
              </span>
              <ArrowUpRight size={18} className="opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
            </div>
            <div>
              <h3 className="font-display font-semibold uppercase text-2xl tracking-tight mb-3">{s.title}</h3>
              <p className="font-mono text-xs leading-relaxed opacity-70">{s.desc}</p>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
